import React, { useEffect, useState, useContext } from "react";
import { useLocation, NavLink, useNavigate } from "react-router-dom";
import { mySpaceMenus, otherUserOffers } from "../constants";
import { useSelector } from "react-redux";
import { AppContext } from "../contexts/AppContext";
import Loader from "./Loader";
import axiosHttp from "../config/axios.interceptor";
import { AuthContext } from "../contexts/AuthContext";

const SpaceMenu = ({ name, planType, otherUserId }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [otherUserPlanType, setOtherUserPlanType] = useState("");
  const [loading, setLoading] = useState(false);
  const appContext = useContext(AppContext);
  const { user } = useContext(AuthContext);
  const userId = user?.userId || user?.data?.data?.userId;
  const userName = user?.userName || user?.data?.data?.userName;

  const getActiveChatNotificationCount = useSelector((state) => state.chat);

  const segments = location.pathname.split("/");

  const lastSegment = segments[segments.length - 1];

  const updateCategoryHandler = (item) => {
    item.name === "Promotions"
      ? appContext.updateCategory("680c89f84f3447f6da04284f")
      : appContext.updateCategory("");
    navigate(item.urlPath === "" ? `/${userName}` : item.urlPath); // Navigate to the route
  };

  return loading ? (
    <Loader />
  ) : (
    <div className="card card-one menu-items">
      {name === "myspace"
        ? mySpaceMenus.map((item) => {
            return (
              <span
                key={item.urlPath}
                className={`space-border ${
                  location.pathname ===
                  (item.urlPath === "" ? `/${userName}` : item.urlPath)
                    ? "txt-active"
                    : ""
                }`}
                onClick={() => {
                  updateCategoryHandler(item);
                }}
              >
                <p
                  className={
                    item.urlPath === ""
                      ? location.pathname === `/${userName}`
                        ? "set-txt cursor-pointer txt-active"
                        : "set-txt cursor-pointer"
                      : location.pathname === `/${item.urlPath}`
                      ? "set-txt cursor-pointer txt-active"
                      : "set-txt cursor-pointer"
                  }
                >
                  <span
                    className={
                      item.urlPath === ""
                        ? location.pathname === `/${userName}`
                          ? "mr-3 svg-path-active"
                          : "mr-3 svg-path"
                        : location.pathname === `/${item.urlPath}`
                        ? "mr-3 svg-path-active"
                        : "mr-3 svg-path"
                    }
                    dangerouslySetInnerHTML={{ __html: item.svgCode }}
                  />
                  <span className="inner-heading"> {item.name}</span>
                  {item.name === "Queries" &&
                    getActiveChatNotificationCount?.activeChatCount !== 0 && (
                      <span className="ml-1 active-chat-count">
                        {getActiveChatNotificationCount?.activeChatCount || 0}
                      </span>
                    )}
                </p>
              </span>
            );
          })
        : name === "user" && otherUserId
        ? otherUserOffers.map((item) => {
            return (
              <NavLink
                to={`../user/${otherUserId}/${item.urlPath}`}
                className="space-border"
                key={item.urlPath}
                onClick={() => {
                  updateCategoryHandler(item);
                }}
              >
                <p
                  className={
                    lastSegment === `${item.urlPath}`
                      ? "set-txt cursor-pointer txt-active"
                      : "set-txt cursor-pointer"
                  }
                >
                  <span
                    className={
                      lastSegment === `${item.urlPath}`
                        ? "mr-3 svg-path-active"
                        : "mr-3 svg-path"
                    }
                    dangerouslySetInnerHTML={{ __html: item.svgCode }}
                  />
                  {item.name}
                </p>
              </NavLink>
            );
          })
        : null}
    </div>
  );
};

export default SpaceMenu;
